import React from 'react';
import { linkTo } from '@prisjakt/ui-app-context';
import { ScrollElement } from '@prisjakt/ui-scroll';
import PreReleaseInformation from '../pre-release-information';
import PriceHistory from '../price-history';
import PriceList from '../price-list';
import ReadableProductInformation from '../readable-product-information';
import Recommendations from '../../../../components/recommendations';
import { PRODUCT_CONTEXT_ID } from '../../constants';
import { Product } from '../../../../types';
import { CurrentCampaign } from '../../types';
import {
  ModelType,
  ModelTypeEnum,
} from '../../../../components/recommendations/types';

const ProductTabMain: React.FC<IProductTabMainProps> = props => {
  const {
    isPreRelease,
    product,
    similarProducts,
    getRecommendationsLink,
    currentCampaign,
    productConditionVisible,
  } = props;

  return (
    <>
      {isPreRelease && product.releaseDate && (
        <PreReleaseInformation
          product={product}
          releaseDate={product.releaseDate}
        />
      )}
      {product.statistics &&
        product.statistics.pageInfo &&
        product.statistics.pageInfo.lowestPrice &&
        isPreRelease && (
          <PriceHistory
            route={linkTo('productPriceHistory', product)}
            productName={product.name}
            {...product.statistics}
          />
        )}
      {isPreRelease && similarProducts?.recommendations?.length ? (
        <Recommendations
          link={getRecommendationsLink(ModelTypeEnum.SIMILAR_PRODUCTS)}
          recommendations={similarProducts.recommendations}
          type={ModelTypeEnum.SIMILAR_PRODUCTS}
          contextId={PRODUCT_CONTEXT_ID}
        />
      ) : null}
      {product.prices && (
        <ScrollElement name="Pricelist" data-test="MainTabContent">
          <PriceList
            {...product}
            prices={product.prices}
            media={product.media}
            productName={product.name}
            adOffset={1}
            campaign={currentCampaign as CurrentCampaign}
            variantGroups={product.variantGroups}
            productConditionVisible={productConditionVisible}
          />
        </ScrollElement>
      )}

      <ReadableProductInformation product={product} />
    </>
  );
};

interface IProductTabMainProps {
  isPreRelease: boolean | '' | null;
  product: Product;
  similarProducts: any;
  getRecommendationsLink: (
    modelType: ModelType
  ) =>
    | {
        title: string;
        url: string;
        onClick: () => void | null;
      }
    | {
        title: string;
        url: string;
        onClick?: undefined;
      }
    | null;
  currentCampaign: any;
  productConditionVisible: boolean;
}

export default ProductTabMain;
